module.exports = __webpack_public_path__ + "images/fa-clock-light.svg";